import { IWFParameter } from "@kuika/kuika-cl-model";
import KuikaSvg from "../../../ui-kit/kuika-svg/kuika-svg";

/** A small glyph hinting a parameter's data type (shared by the Forms tab surfaces). */
export const typeIcon = (dataType: string): string => {
  const key: string = (dataType ?? "").toLowerCase();
  if (key === "boolean") return "circle-check";
  if (key === "date" || key === "datetime" || key === "datetimeoffset") return "calendar-event";
  if (["int16", "int32", "int64", "decimal", "double", "single", "byte", "number"].includes(key)) {
    return "list-numbers";
  }
  if (key === "image") return "image";
  return "text-size";
};

export interface IFormsTabStepOutputsProps {
  /** The step's output parameters resolved to their workflow-parameter metadata (scalars only). */
  params: IWFParameter[];
}

/**
 * The "Step Outputs" chip strip shared by the Workflow Screens and Interactions sub-tabs. Follows
 * the form table's badge color language: Business Object outputs (captured by the form) are blue,
 * internal outputs (set by interactions) are grey — violet stays reserved for the Output badge.
 */
const FormsTabStepOutputs = ({ params }: IFormsTabStepOutputsProps): JSX.Element => (
  <div className="kuika-wf-forms__outputs" data-testid="processFormsStepOutputs">
    <span className="kuika-wf-forms__outputs-label">Step Outputs</span>
    {params.length === 0 ? (
      <span className="kuika-wf-forms__outputs-empty">This step configures no outputs.</span>
    ) : (
      params.map((p: IWFParameter) => {
        const isBo: boolean = p.isBusinessObject === true;
        return (
          <span
            className={`kuika-wf-forms__output-chip${isBo ? " kuika-wf-forms__output-chip--bo" : ""}`}
            key={p.id}
            title={
              isBo
                ? "Business Object parameter — captured by this step's form."
                : "Internal parameter — its value is set by this step's interactions."
            }
          >
            <KuikaSvg
              name={typeIcon(p.dataType)}
              width={12}
              height={12}
              color={isBo ? "var(--blue-7)" : "var(--dark-9)"}
            />
            {p.name} <span className="kuika-wf-forms__output-chip-type">({p.dataType})</span>
          </span>
        );
      })
    )}
  </div>
);

export default FormsTabStepOutputs;
